import api, {prepareQueryParameters} from "@/store/api";
import {randomString} from "@/utils";
import router from "@/router";

export const csrfToken = 'csrf';
export const client = 'client_id';
export const browserId = 'hash';

export const token = () => {
    return localStorage.getItem(csrfToken);
};

export const clientId = () => {
    return localStorage.getItem(client);
};

export const browserHash = () => {
    return localStorage.getItem(browserId);
};

const emptyState = () => {
    return {
        loading: false,
        loadingUser: false,
        currentAccountingDate: null,
        profile: null,
        profileInfo: null,
        assignedToMe: [],
        tempUser: {
            token: null
        },
        assignedToSomeone: [],
        serviceDown: false,
    }
}

export default {
    namespaced: true,
    state: emptyState(),
    actions: {
        testServiceDown(store: any) {
            store.commit('loading', true);
            return new Promise((resolve, reject) => {
                api.get('client-zone-users/service-down').then((response: any) => {
                    store.commit('loading', false);
                    store.commit('setServiceDown', false);
                    resolve(response.data);
                }).catch(error => {
                    store.commit('loading', false);
                    store.commit('setServiceDown', true);
                    reject();
                });
            });
        },
        login(store: any, params: any) {
            store.dispatch('deleteStore');
            return new Promise((resolve, reject) => {
                api.post(`client-zone-users/login`, params).then((response: any) => {
                    store.commit('setToken', response.data.result.token);
                    resolve();
                }).catch((error) => {
                    store.dispatch("alert/warning", error.response.data.result, { root: true });
                    reject();
                });
            });
        },
        loginWithToken(store: any, params: any) {
            return new Promise((resolve, reject) => {
                api.post(`client-zone-users/login-with-token-client-zone`, params).then((response: any) => {
                    store.commit('setToken', response.data.result.token);
                    router.push({name: 'dashboard'});
                    resolve();
                }).catch((error) => {
                    // store.dispatch("alert/warning", error.response.data.result, { root: true });
                    store.commit('removeToken');
                    // router.push({name: 'login'});
                    reject();
                });
            });
        },
        getProfileInfo(store: any) {
            store.commit('loading', true);
            return new Promise((resolve, reject) => {
                api.get('client-zone-users/profile').then(({data}) => {
                    store.commit('setProfileInfo', data.result);
                    store.commit('loading', false);
                    resolve(data.data);
                }).catch(error => {
                    store.commit('setProfileInfo', null);
                    store.commit('loading', false);
                    reject();
                });
            });
        },
        assignedToMe(store: any) {
            // store.commit('loadingUser', true);
            return new Promise((resolve, reject) => {
                api.get('client-zone-users/clients.json').then(({data}) => {
                    store.commit('setAssignedToMe', data.result);
                    resolve();
                    // store.commit('loadingUser', false);
                }).catch(error => {
                    if(error.response.data.code === 500 && error.response.data.message === "Expired token") {
                        store.dispatch('logout');
                        store.commit('setAssignedToMe', []);
                        router.push({name: 'login'});
                    } else {
                        store.dispatch("alert/warning", error.response.data.result, { root: true });
                        reject();
                        store.commit('setAssignedToMe', []);
                    }
                });
            });
        },
        switchUser(store: any, params: any) {
            const items = store.state.assignedToMe.filter((client: { id: any; }) => {
                return client.id === params.clientId;
            })
            store.commit('setTempUser', items[0]);
        },
        logout(store: any) {
            store.commit('removeToken');
        },
        updateProfile(store: any, params: any) {
            if (store.state.tempUser.token) {
                params.clientToken = store.state.tempUser.token;
            }
            return new Promise((resolve, reject) => {
                api.post('client-zone-users/update-profile', params).then(() => {
                    store.dispatch('alert/success', 'Žiadosť o zmenu osobných údajov bola odoslaná.', {root: true});
                    resolve();
                }).catch(() => {
                    reject();
                });
            });
        },
        lostPassword(store: any, params: any) {
            params.link = window.location.origin + process.env.VUE_APP_PUBLIC_PATH + '#/public/reset-password/';
            return new Promise((resolve, reject) => {
                api.post('client-zone-users/lost-password', params).then(() => {
                    resolve();
                }).catch((error) => {
                    store.dispatch("alert/warning", error.response.data.result, { root: true });
                    reject();
                });
            });
        },
        changePassword(store: any, params: any) {
            return new Promise((resolve, reject) => {
                api.post('client-zone-users/change-password', params).then(response => {
                    store.dispatch('alert/success', response.data.result, {root: true});
                    resolve();
                }).catch(error => {
                    store.dispatch('alert/warning', error.response.data.result, {root: true});
                    reject();
                });
            });
        },
        validateToken(store: any, params: any) {
            return new Promise((resolve, reject) => {
                api.get(`client-zone-users/validate-token?${prepareQueryParameters(params)}`).then(() => {
                    resolve();
                }).catch((error) => {
                    store.dispatch('alert/error', 'Neplatný token!', {root: true});
                    router.push({name: 'login'});
                });
            });
        },
        resetPassword(store: any, params: any) {
            return api.post('client-zone-users/reset-password', params).then(() => {
                store.dispatch('alert/success', 'Heslo bolo úspešne zmenené!', {root: true});
                router.push({name: 'login'});
            });
        },
        // sendPinCodeAgain(store: any) {
        //     return api.postWithNotification(store, 'account/send-pin-code-again/' + browserHash(), {}, 'Pin kód bol odoslaný!');
        // },
        // activate(store: any, params: any) {
        //     return api.postWithNotification(store, 'account/activate/' + browserHash(), params, 'Pin kód bol overený!');
        // },
        // newTradeRequest(store: any, params: any) {
        //     return api.putWithNotification(store, 'account/new-trade-request', params, 'Žiadosť bola úspešne odoslaná!');
        // },
        deleteStore(store: any) {
            store.commit('reset');
            store.commit('assets/reset', [], { root: true });
            store.commit('content/reset', [], { root: true });
            store.commit('messages/reset', [], { root: true });
            store.commit('portfolio/reset', [], { root: true });
            store.commit('transactions/reset', [], { root: true });
        }
    },
    mutations: {
        setAccountingDate(state: any, data: any) {
            state.currentAccountingDate = data;
        },
        setAssignedToMe(state: any, items: any) {
            state.assignedToMe = items;
            if (items.length > 0) {
                if (clientId()) {
                    state.tempUser = state.assignedToMe.filter((client: { id: any; }) => {
                        return client.id.toString() === clientId();
                    })[0];
                } else {
                    state.tempUser = items[0];
                    localStorage.setItem(client, items[0].id);
                }
            }
        },
        setTempUser(state: any, item: any) {
            state.tempUser = item;
            if (clientId() === null || clientId() !== item.id.toString()) {
                localStorage.setItem(client, item.id);
                window.location.reload();
            }
        },
        setAssignedToSomeone(state: any, items: any) {
            state.assignedToSomeone = items;
        },
        loading(state: any, status: boolean) {
            state.loading = status;
        },
        loadingUser(state: any, status: boolean) {
            state.loadingUser = status;
        },
        setToken(state: any, token: string) {
            localStorage.setItem(csrfToken, token);
        },
        removeToken() {
            localStorage.removeItem(csrfToken);
            localStorage.removeItem(client);
        },
        setProfile(state: any, profile: any) {
            state.profile = profile;
        },
        setServiceDown(state: any, value: boolean) {
            state.serviceDown = value;
        },
        setProfileInfo(state: any, profile: any) {
            // if (profile.id === 1) {
            //     profile.name = profile.surname = profile.company_name = profile.idcard_no = profile.street = profile.email = profile.phone = '...';
            // }
            state.profileInfo = profile;
        },
        initBrowser() {
            if (browserHash() === null) {
                localStorage.setItem(browserId, randomString(50));
            }
        },
        reset (state: any) {
            Object.assign(state, emptyState());
        }
    }
};
